import { useTranslation } from 'react-i18next';
import useAction from 'hooks/useAction';
import { pushBackDoNotSellMyInfo } from 'store/modals/actions';
import Alooma from 'services/alooma';
import * as ALOOMA from 'consts/alooma';
import useShouldShowCCPAForm from 'hooks/useShouldShowCCPAForm';
import { InfoPageUnderlinedText } from '../InfoPageUnderlinedText/InfoPageUnderlinedText.style';
import { InfoPageDarkText } from '../InfoPageDarkText/InfoPageDarkText.style';

const OpenCCPAFormButton = () => {
  const { t } = useTranslation();
  const shouldShowCCPAForm = useShouldShowCCPAForm();

  const contextDataAttrs = Alooma.useContextDataAttrs();
  const pushBackDoNotSellMyInfoFunc = useAction(pushBackDoNotSellMyInfo);
  const openModal = () => pushBackDoNotSellMyInfoFunc();

  return shouldShowCCPAForm ? (
    <InfoPageUnderlinedText
      {...contextDataAttrs}
      data-alooma-element={ALOOMA.ELEMENTS.DONT_SELL_PERSONAL_INFO}
      type="text"
      size="medium"
      onClick={openModal}
      role="button"
    >
      <InfoPageDarkText>{t('app:dontSellMyPersonalInformation')}</InfoPageDarkText>
    </InfoPageUnderlinedText>
  ) : null;
};

export default OpenCCPAFormButton;
